var _mask, _path, _path2, _circle, _circle2, _ellipse, _ellipse2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrations({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6983_46873",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C8.89543 4 8 4.89543 8 6V24C8 25.1046 8.89543 26 10 26H20C21.1046 26 22 25.1046 22 24V6C22 4.89543 21.1046 4 20 4H10ZM11 6C10.4477 6 10 6.44772 10 7V23C10 23.5523 10.4477 24 11 24H19C19.5523 24 20 23.5523 20 23V7C20 6.44772 19.5523 6 19 6H11Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C8.89543 4 8 4.89543 8 6V24C8 25.1046 8.89543 26 10 26H20C21.1046 26 22 25.1046 22 24V6C22 4.89543 21.1046 4 20 4H10ZM11 6C10.4477 6 10 6.44772 10 7V23C10 23.5523 10.4477 24 11 24H19C19.5523 24 20 23.5523 20 23V7C20 6.44772 19.5523 6 19 6H11Z",
    fill: "#D1D1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 6.55229 10.5523 7 10 7V1C7.23858 1 5 3.23857 5 6H11ZM11 24V6H5V24H11ZM10 23C10.5523 23 11 23.4477 11 24H5C5 26.7614 7.23857 29 10 29V23ZM20 23H10V29H20V23ZM19 24C19 23.4477 19.4477 23 20 23V29C22.7614 29 25 26.7614 25 24H19ZM19 6V24H25V6H19ZM20 7C19.4477 7 19 6.55228 19 6H25C25 3.23858 22.7614 1 20 1V7ZM10 7H20V1H10V7ZM13 7C13 8.10457 12.1046 9 11 9V3C8.79086 3 7 4.79086 7 7H13ZM13 23V7H7V23H13ZM11 21C12.1046 21 13 21.8954 13 23H7C7 25.2091 8.79086 27 11 27V21ZM19 21H11V27H19V21ZM17 23C17 21.8954 17.8954 21 19 21V27C21.2091 27 23 25.2091 23 23H17ZM17 7V23H23V7H17ZM19 9C17.8954 9 17 8.10457 17 7H23C23 4.79086 21.2091 3 19 3V9ZM11 9H19V3H11V9Z",
    fill: "#455079",
    mask: "url(#path-1-inside-1_6983_46873)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.25,
    cy: 11,
    r: 2,
    transform: "rotate(-180 3.25 11)",
    stroke: "#455079",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.25,
    cy: 19,
    r: 2,
    transform: "rotate(-180 3.25 19)",
    stroke: "#455079",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.75,
    cy: 11,
    rx: 3,
    ry: 3,
    transform: "rotate(-180 26.75 11)",
    fill: "#455079"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.75,
    cy: 19,
    rx: 3,
    ry: 3,
    transform: "rotate(-180 26.75 19)",
    fill: "#455079"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11L8.5 11",
    stroke: "#455079",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19L8 19",
    stroke: "#455079",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11L26.5 11",
    stroke: "#455079",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 19H26.75",
    stroke: "#455079",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.f67da255b71863bfadbd73da30993079.svg";
export { ForwardRef as ReactComponent };